import {EthicsComplianceAnswerModel} from '../Model/EthicsComplianceAnswer.model';

export class UtilEthicsCompliance {
static CreateModel(
  data: EthicsComplianceAnswerModel[], IdQuestionDetail: number, Answer: string,
  IdRequest: number, Section: number, Question: number,
  SubQuestion: number): EthicsComplianceAnswerModel {
  const itemAnswers = new EthicsComplianceAnswerModel();
  itemAnswers.Id = this.GetIdAnswer(data, IdQuestionDetail);
  itemAnswers.IdQuestionDetail = IdQuestionDetail;
  itemAnswers.Answer = Answer;
  itemAnswers.IdRequest = IdRequest;
  itemAnswers.Section = Section;
  itemAnswers.Question = Question;
  itemAnswers.SubQuestion = SubQuestion;
  return itemAnswers;
}
static GetIdAnswer(answers: EthicsComplianceAnswerModel[], IdQuestionDetail: number): number {
  return answers != null ?
    answers.find(x => x.IdQuestionDetail === IdQuestionDetail) != null ?
      answers.find(x => x.IdQuestionDetail === IdQuestionDetail).Id : 0   : 0;
}
static GetAnswer(data: EthicsComplianceAnswerModel[], question: number, subQuestion: number ): string {
  return data != null ? data.find(x => x.Question === question && x.SubQuestion === subQuestion) ?
    data.find(x => x.Question === question && x.SubQuestion === subQuestion).Answer : '' : '';
}
static GetLabel(data: EthicsComplianceAnswerModel[], question: number): string {
  return data != null ? data.find(x => x.Question === question && x.SubQuestion == null) ?
    data.find(x => x.Question === question && x.SubQuestion == null).Answer : null : null;
}
}
